// src/pages/CustomerProfile.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import './ProfilePages.css';

const CustomerProfile = () => {
  const { user, logout } = useAuth();
  const [stats, setStats] = useState({ posted: 0, completed: 0, avgRating: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    const fetchStats = async () => {
      const [jobsSnap, reviewsSnap] = await Promise.all([
        getDocs(query(collection(db, 'jobs'),    where('customerId', '==', user.uid))),
        getDocs(query(collection(db, 'reviews'), where('customerId', '==', user.uid))),
      ]);
      const jobs      = jobsSnap.docs.map(d => d.data());
      const completed = jobs.filter(j => j.status === 'Completed').length;
      const ratings   = reviewsSnap.docs.map(d => d.data().rating).filter(Boolean);
      const avgRating = ratings.length
        ? Math.round((ratings.reduce((s, r) => s + r, 0) / ratings.length) * 10) / 10
        : null;
      setStats({ posted: jobs.length, completed, avgRating });
      setLoading(false);
    };
    fetchStats();
  }, [user]);

  if (!user) return <div className="page-wrapper"><p>Please <Link to="/login">log in</Link>.</p></div>;

  return (
    <div className="page-wrapper page-wrapper-sm">
      <h1 className="section-title">MY <span>PROFILE</span></h1>
      <div className="card profile-card">
        <div className="profile-avatar">{user.name?.charAt(0) || 'C'}</div>
        <div className="profile-name">{user.name}</div>
        <div className="profile-email">{user.email}</div>
        <div className="profile-type badge badge-teal">Customer</div>
        <hr className="divider" />
        <div className="profile-stats">
          <div className="pstat-sm">
            <div className="pstat-v">{loading ? '—' : stats.posted}</div>
            <div className="pstat-l">Jobs Posted</div>
          </div>
          <div className="pstat-sm">
            <div className="pstat-v">{loading ? '—' : stats.completed}</div>
            <div className="pstat-l">Completed</div>
          </div>
          <div className="pstat-sm">
            <div className="pstat-v">{loading ? '—' : stats.avgRating ?? '—'}</div>
            <div className="pstat-l">Avg Rating Given</div>
          </div>
        </div>
        <hr className="divider" />
        <Link to="/customer-dashboard" className="btn btn-primary btn-full">GO TO DASHBOARD</Link>
        <button className="btn btn-secondary btn-full" style={{marginTop:'10px'}} onClick={logout}>LOGOUT</button>
      </div>
    </div>
  );
};

export default CustomerProfile;
